<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { VButtonInvisible } from '@/modules/shared/components'
import { RouterLinkBack } from '@/modules/shared/components'
import { useAuthStore } from '@/modules/auth/stores/auth-store'
import { useNotificationStore } from '@/modules/shared/stores/notification-store'
import TheLayout from '@/modules/shared/layouts/the-layout.vue'
import MessageComposer from '../components/MessageComposer.vue'
import { useMessagingStore } from '../stores/messaging-store'
import type { CreateMessagePayload } from '../types'

const router = useRouter()
const authStore = useAuthStore()
const notificationStore = useNotificationStore()
const messagingStore = useMessagingStore()

const submitting = ref(false)
const submitError = ref<string | null>(null)

onMounted(() => {
  if (!authStore.is_site_or_group_admin) {
    router.replace({ name: 'messaging.index' })
  }
})

const onSubmit = async (payload: CreateMessagePayload) => {
  submitting.value = true
  submitError.value = null

  try {
    const message = await messagingStore.createMessage(payload)
    notificationStore.enqueue('success', 'Message sent')
    router.push({ name: 'messaging.show', params: { id: message.id } })
  } catch (e) {
    submitError.value = e instanceof Error ? e.message : 'Failed to send message'
  } finally {
    submitting.value = false
  }
}

const onCancel = () => {
  router.push({ name: 'messaging.index' })
}
</script>

<template>
  <TheLayout>
    <div class="-mt-8 mb-6">
      <RouterLinkBack :to="{ name: 'messaging.index' }">
        <VButtonInvisible>&larr; Back to Messages</VButtonInvisible>
      </RouterLinkBack>
    </div>

    <MessageComposer :submitting="submitting" :submit-error="submitError" @submit="onSubmit" @cancel="onCancel" />
  </TheLayout>
</template>
